export enum WebRTCErrorCode {
  CONFIGURATION_ERROR_NODE = "argument_error_node" /*When node has not been provided*/,
  LAUNCH_ERROR = "error_launch" /* Generic launch error (while polling) */,
  PLAY_ERROR = "error_play" /** Generic play error */,
}
export interface WebRTCError {
  code: string;
  message: string;
}
